<template>
  <span
    class="text-button"
    :class="{ active }"
    @click="$emit('click')">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text-button {
  color: $grey05;
  font-size: 1rem;
  cursor: pointer;

  &.active {
    color: $l-blue;
  }
}
</style>